<template>
  <!--button按钮-->
  <tkui-button
    :class="{'raised': isRaised, 'border': isBorder, 'rounded': isRounded}"
    class="small"
    style="margin: 0;"
    :disabled="disabled"
    :style="{backgroundColor: bgColor,
     borderColor: bdColor + '!important', color: textColor,
      minWidth: minWidth + 'px', height: height + 'px', lineHeight: height + 'px'}"
  >
    {{btnText}}
  </tkui-button>
</template>

<script>
export default {
  props: {
    btnText: {
      type: String,
      default: 'button'
    },
    isRaised: {
      type: Boolean,
      default: false
    },
    isBorder: {
      type: Boolean,
      default: true
    },
    isRounded: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0)'
    },
    bdColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    minWidth: {
      type: Number,
      default: 60
    },
    height: {
      type: Number,
      default: 30
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
